import React, { Suspense, useMemo, useState, useEffect, useRef } from 'react'
import { addSitesToGroup, getAllSitesAPI, getDashboardStatsByGroup, getGroupSites, getGroupStats, updateCustomerNumber, getGroupUsers, getRTDashboardStatsByGroup, getSiteAnalytics, editGroupDetails, getGroups } from '../../Api Methods/Api';
import { Await, defer, Outlet, useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classes from './GroupSites.module.css'
import statClasses from '../Dashboard/Dashboard.module.css'
import FilterUsersDeviceSearch from '../../components/PowerSearch/FilterUsersDeviceSearch';
import Oval from 'react-loading-icons/dist/esm/components/oval';
import DevicesGrid from '../../components/GridList/DevicesGrid';
import DataManager from '../../hooks/DataManager';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import DropDownForm from '../../components/forms/DropdownCreateGroup';
import DevicesList from '../../components/GridList/DevicesList';
import StatsContainer from './StatsContainer';
import Stats2 from '../../components/UI/Stats/Stats2';
import StatCard from '../../components/UI/Stats/StatCard';
import CategoryFilter from '../../components/PowerSearch/CategoryFilter';
import { filter, last } from 'rxjs';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import { act } from 'react';
import { serviceActions } from '../../store/service-Slice';
import AllSitesSearchBar from '../AllSites/allSitesSearchBar';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import GroupSitesSearchBar from './groupSitesSearchBar';
import { InputText } from "primereact/inputtext";
import UserList from '../User Management/UserManagementList';
import { Doughnut, Bar } from 'react-chartjs-2';
import AddPortalUser from './AddPortalUser';
import CreateUserPortal from '../../Register/CreateUserPortal';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { InputTextarea } from 'primereact/inputtextarea';
import CCTVAnalyticsGroup from '../CCTVIntegrations/CCTVAnalyticsGroup';
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { FloatLabel } from 'primereact/floatlabel';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { SelectButton } from 'primereact/selectbutton';

import bin from '../../assets/portalAssets/bin.png';

ChartJS.register(ArcElement, Tooltip, Legend);

const centerTextPlugin = {
    id: 'centerText',
    beforeDraw(chart) {
        const cfg = chart.config.options.plugins.centerText;
        if (!cfg?.show) return;
        const { ctx, chartArea } = chart;
        const cx = (chartArea.left + chartArea.right) / 2;
        const cy = (chartArea.top + chartArea.bottom) / 2;
        ctx.save();
        ctx.font = '600 16px -apple-system, BlinkMacSystemFont, sans-serif';
        ctx.fillStyle = '#5c5c5c';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(cfg.text, cx, cy);
        ctx.restore();
    },
};
ChartJS.register(centerTextPlugin);

const C = {
    critical: '#df7474', warning: '#efbc65', healthy: '#5fdc8d',
    online: '#60e08f', offline: '#ee6d6d', stale: '#fec665',
    missed1poll: '#e8944f', powerDown: '#d95d5d', unknown: '#9ca3af',
    mains: '#6298ee', solar: '#b2e368', battery: '#f3b853',
    poor: '#d95d5d', fair: '#e8944f', good: '#5fdc8d',
};

const makeChartOptions = (total) => ({
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
        legend: {
            position: 'bottom',
            labels: {
                font: { size: 11 }, padding: 10, boxWidth: 10, usePointStyle: true,
                generateLabels: (chart) => {
                    const { labels, datasets } = chart.data;
                    return labels.map((label, i) => ({
                        text: `${label}  ${(datasets[0].data[i] ?? 0).toLocaleString()}`,
                        fillStyle: datasets[0].backgroundColor[i],
                        strokeStyle: datasets[0].backgroundColor[i],
                        pointStyle: 'circle', hidden: false, index: i,
                    }));
                },
            },
        },
        tooltip: { enabled: true },
        centerText: { show: true, text: total.toLocaleString() },
    },
});

const dataManager = new DataManager();

const GsSkeletonCard = () => (
    <div className={classes.skeletonCard}>
        <div className={classes.skeletonTop}>
            <div className={classes.skeletonBar} style={{ height: '18px', width: '60%' }} />
            <div className={classes.skeletonBar} style={{ height: '24px', width: '24px', borderRadius: '50%' }} />
        </div>
        <div className={classes.skeletonBar} style={{ height: '32px', width: '40%' }} />
    </div>
);

const GsSkeletonChart = () => (
    <div className={classes.chartCard}>
        <div className={classes.skeletonBar} style={{ height: '14px', width: '55%', marginBottom: '16px' }} />
        <div className={classes.skeletonCircle} />
        <div className={classes.skeletonBar} style={{ height: '10px', width: '80%', marginTop: '14px' }} />
    </div>
);

const GsSkeletonBarChart = () => (
    <div className={classes.chartCard}>
        <div className={classes.skeletonBar} style={{ height: "14px", width: "40%", marginBottom: "16px" }} />
        <div className={classes.skeletonBar} style={{ height: "337px", width: "100%" }} />
    </div>
);

const GsSkeletonTableCard = () => (
    <div className={classes.chartCard}>
        <div className={classes.skeletonBar} style={{ height: "14px", width: "15%", marginBottom: "16px" }} />
        <div style={{ border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: "8px", padding: "8px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "12px 8px", borderBottom: "1px solid rgba(0,0,0,0.1)" }}>
                <div className={classes.skeletonBar} style={{ height: "14px", width: "80px" }} />
                <div className={classes.skeletonBar} style={{ height: "14px", width: "100px" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "14px 8px" }}>
                <div className={classes.skeletonBar} style={{ height: "12px", width: "55%" }} />
                <div className={classes.skeletonBar} style={{ height: "12px", width: "40px" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "14px 8px" }}>
                <div className={classes.skeletonBar} style={{ height: "12px", width: "45%" }} />
                <div className={classes.skeletonBar} style={{ height: "12px", width: "40px" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "14px 8px" }}>
                <div className={classes.skeletonBar} style={{ height: "12px", width: "60%" }} />
                <div className={classes.skeletonBar} style={{ height: "12px", width: "40px" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "14px 8px" }}>
                <div className={classes.skeletonBar} style={{ height: "12px", width: "50%" }} />
                <div className={classes.skeletonBar} style={{ height: "12px", width: "40px" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "14px 8px" }}>
                <div className={classes.skeletonBar} style={{ height: "12px", width: "40%" }} />
                <div className={classes.skeletonBar} style={{ height: "12px", width: "40px" }} />
            </div>
        </div>
    </div>
);

const GsSkeletonMainTableCard = () => (
    <div className={classes.chartCard}>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            </div>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0" }}>
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={classes.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
    </div>
);


const GsDonutCard = ({ title, labels, values, colors, centerText }) => {
    const total = values.reduce((a, b) => a + b, 0);
    if (total === 0) return null;
    const data = { labels, datasets: [{ data: values, backgroundColor: colors, borderWidth: 0, hoverOffset: 4 }] };

    const displayText = centerText !== undefined ? centerText : total.toLocaleString();
    return (
        <div className={classes.chartCard}>
            <p className={classes.chartTitle}>{title}</p>
            <div className={classes.donutContainer}>
                <Doughnut data={data} options={makeChartOptions(displayText)} />
            </div>
        </div>
    );
};

const GsBarCard = ({ title, labels, values, colors, datasets, topUserData, onUserClick }) => {
    const data = {
        labels,
        datasets: datasets || [{ label: "", data: values, backgroundColor: colors, borderWidth: 0 }],
    };
    const legendColors = ["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e", "#1eb9c7"];
    return (
        <div className={classes.chartCard}>
            <p className={classes.chartTitle}>{title}</p>
            {topUserData && (
                <div className={classes.userLegend}>
                    {topUserData.slice(0, 10).map((item, index) => (
                        <div
                            key={item.fullName}
                            className={classes.userLegendItem}
                            onClick={() => {
                                if (item.userID != null && onUserClick) {
                                    onUserClick(item.userID, item.fullName);
                                }
                            }}
                            style={{ cursor: item.userID != null && onUserClick ? 'pointer' : 'default' }}
                        >
                            <span
                                className={classes.userLegendDot}
                                style={{ backgroundColor: legendColors[index % legendColors.length] }}
                            />
                            <span>{item.fullName}</span>
                        </div>
                    ))}
                </div>
            )}
            <div className={classes.barContainer} style={{ height: "300px" }}>
                <Bar data={data} options={{ indexAxis: 'y', responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false }, tooltip: { enabled: true } }, scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } }, y: { grid: { display: false }, ticks: { autoSkip: false } } } }} />
            </div>
        </div>
    );
}

const GsTableCard = ({ title, topUserData, onUserClick }) => {
    return (
    <div className={classes.chartCard}>
        <p className={classes.chartTitle}>{title}</p>
        <DataTable value={topUserData} scrollable scrollHeight='400px' stripedRows style={{ border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: "8px", padding: "8px"}}>
            <Column 
                field="fullName"
                header="User"
                body={(rowData) => (
                    <span 
                    className={classes.tableUser}
                    onClick={() => (onUserClick(rowData.userID, rowData.fullName))}>
                        {rowData.fullName}                   
                    </span>
                )}
            />
            <Column field="total_actions" header="Total Actions"></Column>
        </DataTable>
    </div>
    );
}

const GsRTSectionHeader = ({ title, lastRTUpdate, secondsAgo, formatSecondsAgo }) => (
    <div className={classes.sectionHeader}>
        <p className={classes.sectionTitle}>{title}</p>
        {lastRTUpdate && <span className={classes.lastUpdated}>Updated {formatSecondsAgo(secondsAgo)}</span>}
    </div>
);
const filterOptions = ["All Users", "Exclude Portal Users"]

const SectionHeaderTime = ({ title, times, selectedTime, setSelectedTime, portalFilter, setPortalFilter }) => (
    <div className={statClasses.sectionHeaderTime}>
        <div style={{ display: "flex", alignItems: "baseline", gap: "12px" }}>
            <p className={statClasses.sectionTitle}>{title}</p>
        </div>
        <div className={statClasses.timeDropdown}>
            <SelectButton 
                className={classes.filterToggle}
                value={portalFilter} 
                onChange={(e) => setPortalFilter(e.value)} 
                options={filterOptions} />
            <div className={statClasses.timeButtons}>
                {times.map((time) => (
                    <button
                        key={time}
                        className={selectedTime === time ? statClasses.timeButtonActive : statClasses.timeButton}
                        onClick={() => setSelectedTime(time)}
                    >
                        {time}
                    </button>
                ))}
            </div>
        </div>
    </div>
);
const GroupSites = () => {

    const [groupSites, setGroupSites] = useState([]);
    const [groupDashboardStats, setGroupDashboardStats] = useState();
    const [groupRTDashboardStats, setGroupRTDashboardStats] = useState();
    const [topUserStats, setTopUserStats] = useState();
    const [allUserStats, setAllUserStats] = useState([]);
    const [isLoadingRT, setIsLoadingRT] = useState(true);
    const [lastRTUpdate, setLastRTUpdate] = useState(null);
    const [secondsAgo, setSecondsAgo] = useState(0);
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const role = useSelector(state => state.auth.role);
    const [isloading, setIsLoading] = useState(false);
    const [isLoadingSites, setIsLoadingSites] = useState(true)
    const [groupMode, setGroupMode] = useState(false);
    const dataManager = new DataManager();
    const groupName = sessionStorage.getItem('groupClicked');
    const groupPath = sessionStorage.getItem('groupPath');
    const groupPathToDisplay = groupPath.replace(/>/g, '  |  ');
    const groupID = sessionStorage.getItem('groupClickedID');
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);
    const [selectedTime, setSelectedTime] = useState("7D");
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [filters] = useState({
        fullName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        email: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const scheduleRequestId = useRef(0);
    const navigate = useNavigate();
    const companyName = useSelector(state => state.auth.companyName);
    const apiDataRef = useRef({ token, client, companyName });
    apiDataRef.current = { token, client, companyName };
    const apiData = {
        token,
        client
    }
    const dispatch = useDispatch();


    const handleUserClick = (userID, fullName) => {
        dataManager.setItem('clickedUserID', userID);
        localStorage.setItem('clickedUserID', userID);
        localStorage.setItem('ClickedUserFullName', fullName);
        navigate('/Dashboard/Users/UserSites/');
    };

    const [buttonText, setButtonText] = useState('Edit sites')
    const checkedItems = useState(dataManager.selectedSites.value || []);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [modalComponent, setModalComponent] = useState();
    const [title, setTitle] = useState('');
    const [showMassSettings, setShowMassSettings] = useState(false)

    const [removeVisible, setRemoveVisible] = useState(false)
    const [successVisible, setSuccessVisible] = useState(false)
    const [failVisible, setFailVisible] = useState(false)
    const [portalUsersVisible, setPortalUsersVisible] = useState(false)
    const [portalUsers, setPortalUsers] = useState([])
    const [portalUsersLoading, setPortalUsersLoading] = useState(false)
    const [portalUsersUpdate, setPortalUsersUpdate] = useState(0)
    const [givePortalAccessVisible, setGivePortalAccessVisible] = useState(false)
    const [createUserVisible, setCreateUserVisible] = useState(false)

    const groups = JSON.parse(localStorage.getItem('groups'));
    const [groupObject, setGroupObject] = useState(groups.find(g => g.id === Number(groupID)));

    const [filteredData, setFilteredData] = useState([]) //Will be from cache eventually
    const service = useSelector(state => state.service);

    //Filters
    const [active, setActive] = useState(service.gsActive)
    const [online, setOnline] = useState(service.gsOnline)
    const [offline, setOffline] = useState(service.gsOffline)
    const [deviceTag, setDeviceTag] = useState(service.gsDeviceTag)
    const [cloudController, setCloudController] = useState(service.gsCloudController)
    const [davantis, setDavantis] = useState(service.gsDavantis)
    const [g2cc, setG2cc] = useState(service.gsG2cc)
    const [ESP, setESP] = useState(service.gsESP)
    const [RPi, setRPi] = useState(service.gsRPi)
    const [groupName2, setGroupName2] = useState(groupName)
    const [includeSubgroups, setIncludeSubgroups] = useState(service.gsIncludeSubgroups)
    const [noTag, setNoTag] = useState(service.gsNoTag)
    const [searchTerm, setSearchTerm] = useState(service.gsSearchTerm)
    const [noUsers, setNoUsers] = useState(service.gsNoUsers)
    const [liveViewStatus, setLiveViewStatus] = useState(service.gsLiveViewStatus)
    const [scheduleOnly, setScheduleOnly] = useState(service.gsScheduleOnly)
    const [hasAjax, setHasAjax] = useState(service.gsHasAjax)
    const [hasHik, setHasHik] = useState(service.gsHasHik)
    const [hasAIBOX, setHasAIBOX] = useState(service.gsHasAIBOX)
    const [hasDahua, setHasDahua] = useState(service.gsHasDahua)
    const [hasPadlock, setHasPadlock] = useState(service.gsHasPadlock)
    const [hasKeybox, setHasKeybox] = useState(service.gsHasKeybox)
    const [hasGateway, setHasGateway] = useState(service.gsHasGateway)
    const [hasSigfox, setHasSigfox] = useState(service.gsHasSigfox)
    const [hasIndSigfox, setHasIndSigfox] = useState(service.gsHasIndSigfox)
    const [hasEfento, setHasEfento] = useState(service.gsHasEfento)
    const [hasTeltonika, setHasTeltonika] = useState(service.gsHasTeltonika)
    const [hasSchedules, setHasSchedules] = useState(service.gsHasSchedules)
    const [hasTempSchedules, setHasTempSchedules] = useState(service.gsHasTempSchedules)
    const [activePinCount, setActivePinCount] = useState(service.gsActivePinCount)
    const [ruleV2Owner, setRuleV2Owner] = useState(service.gsRuleV2Owner)
    const [ruleV2Parent, setRuleV2Parent] = useState(service.gsRuleV2Parent)
    const [ruleV2Affected, setRuleV2Affected] = useState(service.gsRuleV2Affected)
    const [connectionIssues, setConnectionIssues] = useState(service.gsConnectionIssues)
    const [hasCamerasLinked, setHasCamerasLinked] = useState(service.gsHasCamerasLinked)
    const [billable, setBillable] = useState(service.gsBillable)
    const [billingFrequency, setBillingFrequency] = useState(service.gsBillingFrequency)
    const [billedTo, setBilledTo] = useState(service.gsBilledTo)

    //Sorts
    const [sortAsc, setSortAsc] = useState(service.gsSortAsc) //descending
    const [sUserCount, setSUserCount] = useState(service.gsSUserCount)
    const [sCreated, setSCreated] = useState(service.gsSCreated) //active by default
    const [sFirmware, setSFirmware] = useState(service.gsSFirmware)
    const [sName, setSName] = useState(service.gsSName)
    const [sCameraCount, setSCameraCount] = useState(service.gsSCameraCount)
    const [sDateOfSale, setSDateOfSale] = useState(service.gsSDateOfSale)
    const [sLastInvoice, setSLastInvoice] = useState(service.gsSLastInvoice)
    const [sDateMadeActive, setSDateMadeActive] = useState(service.gsSDateMadeActive)

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    const [pageOffset, setPageOffset] = useState(0)
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
    const [update, setUpdate] = useState(0)
    const [submit, setSubmit] = useState(0)

    const [changeCustomerNumber, setChangeCustomerNumber] = useState(false)
    const [billingReportVisible, setBillingReportVisible] = useState(false)
    const [billingCosts, setBillingCosts] = useState({ site: '', cctvSite: '', scheduleOnly: '', liveView: '', padlock: '', keybox: '', sensor: '', user: '', gateway: '' })
    const [activeTab, setActiveTab] = useState(0);
    const [portalFilter, setPortalFilter] = useState("All Users");

    const times = ["7D", "1M", "3M"];

    const now = new Date();
    const last7 = new Date();
    last7.setDate(now.getDate() - 7);
    const last30 = new Date();
    last30.setDate(now.getDate() - 30);
    const last90 = new Date();
    last90.setDate(now.getDate() - 90);
    const last8Years = new Date();
    last8Years.setDate(now.getDate() - 2750);

    
    const [permissionsVisible, setPermissionsVisible] = useState(false);
    const [pEnableSupport, setPEnableSupport] = useState(!!groupObject?.supportEnabled);
    const [pAllowSiteCreation, setPAllowSiteCreation] = useState(!!groupObject?.allowSiteCreation);
    const [pBillingApproved, setPBillingApproved] = useState(!!groupObject?.billingEnabled);
    const [pEnableGroupCreation, setPEnableGroupCreation] = useState(!!groupObject?.allowGroupCreation);
    const [pAccountApproved, setPAccountApproved] = useState(!!groupObject?.accountApproved);
    const [pIsOnDD, setPIsOnDD] = useState(!!groupObject?.isOnDD);

    const [hasIons, setHasIons] = useState(false)
    const [hasLocks, setHasLocks] = useState(false)
    const [hasKeyboxes, setHasKeyboxes] = useState(false)
    const [hasGateways, setHasGateways] = useState(false)
    const [hasSensors, setHasSensors] = useState(false)
    const [hasCCTV, setHasCCTV] = useState(false)

    const [billableSensorCount, setBillableSensorCount] = useState(0)

    const [customerNumber, setCustomerNumber] = useState(groupObject.customerNumber ?? "");

    const isAllowed = companyName == "EyeSpyFX" || companyName == "KNOWIO" ? true : false
    const isEyeSpyFX = companyName === "EyeSpyFX";
    const myCompanyGroup = groups?.find(g => g.name === companyName);

    const permissionItems = [
        (isEyeSpyFX || !!myCompanyGroup?.supportEnabled)     && { id: "enableSupport",      label: "Enable Inniovate ticket creation",        checked: pEnableSupport,       set: setPEnableSupport },
        (isEyeSpyFX || !!myCompanyGroup?.allowSiteCreation)  && { id: "allowSiteCreation",  label: "Allow site creation",   checked: pAllowSiteCreation,   set: setPAllowSiteCreation },
        (isEyeSpyFX || !!myCompanyGroup?.allowGroupCreation) && { id: "allowGroupCreation", label: "Enable group creation", checked: pEnableGroupCreation, set: setPEnableGroupCreation },
        isEyeSpyFX && { id: "billingEnabled", label: "Set billing approved", checked: pBillingApproved, set: setPBillingApproved },
        isEyeSpyFX && { id: "isOnDD",         label: "Is on Direct Debit",  checked: pIsOnDD,          set: setPIsOnDD },
    ].filter(Boolean);

    const [invoiceDetails, setInvoiceDetails] = useState({
        fromName: 'Inniovate',
        fromAddress: '2-4 Loy Street, Cookstown, Northern Ireland, BT80 8PE',
        fromPhone: '028 8639 0001',
        fromEmail: 'admin@inniovate.com',
        toName: groupName || '',
        toAddress: '',
        toCustomerNumber: String(groupObject?.customerNumber ?? ''),
        invoiceNumber: 'INV-001',
        invoiceDate: new Date().toLocaleDateString('en-GB'),
        dueDate: '',
        notes: '',
    })

    const HandleShowModal = () => {
        ModalDialog.current.open();
    };

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    };

    useEffect(() => {

        const offset = pageSize * (pageFetchedIndex - 1);
        setPageOffset(offset);

        let body = {
            "active": Number(active),
            "pageSize": Number(pageSize),
            "pageOffset": Number(offset),
            "online": Number(online),
            "offline": Number(offline),
            "deviceTag": deviceTag,
            "cloudController": Number(cloudController),
            "davantis": Number(davantis),
            "g2cc": Number(g2cc),
            "ESP": Number(ESP),
            "RPi": Number(RPi),
            "groupName": groupName,
            "includeSubgroups": 1,
            "noTag": Number(noTag),
            "searchTerm": searchTerm,
            "noUsers": Number(noUsers),
            "liveViewStatus": Number(liveViewStatus),
            "scheduleOnly": Number(scheduleOnly),
            "hasAjax": Number(hasAjax),
            "hasHik": Number(hasHik),
            "hasAIBOX": Number(hasAIBOX),
            "hasDahua": Number(hasDahua),
            "hasPadlock": Number(hasPadlock),
            "hasKeybox": Number(hasKeybox),
            "hasGateway": Number(hasGateway),
            "hasSigfox": Number(hasSigfox),
            "hasIndSigfox": Number(hasIndSigfox),
            "hasEfento": Number(hasEfento),
            "hasTeltonika": Number(hasTeltonika),
            "hasSchedules": Number(hasSchedules),
            "hasTempSchedules": Number(hasTempSchedules),
            "activePinCount": Number(activePinCount),
            "sortAsc": Number(sortAsc),
            "sUserCount": Number(sUserCount),
            "sCreated": Number(sCreated),
            "sFirmware": Number(sFirmware),
            "sName": Number(sName),
            "sCameraCount": Number(sCameraCount),
            "ruleV2Owner": Number(ruleV2Owner),
            "ruleV2Parent": Number(ruleV2Parent),
            "ruleV2Affected": Number(ruleV2Affected),
            "connectionIssues": Number(connectionIssues),
            "hasCamerasLinked": Number(hasCamerasLinked),
            "billable": Number(billable),
            "billingFrequency": Number(billingFrequency),
            "billedTo": Number(billedTo),
            "sDateOfSale": Number(sDateOfSale),
            "sLastInvoice": Number(sLastInvoice),
            "sDateMadeActive": Number(sDateMadeActive)
        }

        HandleGetGroupSites(body)

    }, [submit, pageSize, pageFetchedIndex, online, offline, deviceTag, cloudController, davantis, g2cc, ESP, RPi, groupName, includeSubgroups, noTag, active, noUsers, liveViewStatus, scheduleOnly, hasAjax, hasHik, hasAIBOX, hasDahua, hasPadlock, hasKeybox, hasSigfox, hasIndSigfox, hasEfento, hasTeltonika, hasSchedules, activePinCount, sortAsc, sUserCount, sCreated, sFirmware, sName, sCameraCount, ruleV2Owner, ruleV2Affected, ruleV2Parent, connectionIssues, hasCamerasLinked, billable, billingFrequency, billedTo, sDateOfSale, sLastInvoice, sDateMadeActive])

    useEffect(() => {
        const delay = setTimeout(() => {
            setSubmit(prev => !prev);
        }, 700);

        //store it to reuse later
        dispatch(serviceActions.setGSSearchTerm(searchTerm))

        return () => clearTimeout(delay);
    }, [searchTerm]);



    const successModal = () => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#858585" }}>Action completed successfully</h3>
                <br></br>
            <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
            </div>
        )
        HandleShowModal();
    }

    const ModalDialog = useRef();

    const location = useLocation();
    const isGroupUsersPage = location.pathname.includes('GroupUsers'); // Check if on GroupUsers page

    let data;
    let statsData;

    useEffect(() => {
        const subscription = dataManager.selectedSites.subscribe((sites) => {
            setButtonText(sites.length > 0 ? 'Choose group' : 'Cancel');
        });

        return () => subscription.unsubscribe();
    }, []);

    const HandleGetGroupSites = async (body) => {
        setIsLoadingSites(true)
        const response = await getAllSitesAPI(apiData, body, dispatch)
        setResultCount(response.data[0][0].totalCount)
        setFilteredData(response.data[1])
        setTotalPages(Math.ceil(response.data[0][0].totalCount / pageSize));
        setIsLoadingSites(false)
    };


    const HandleGetGroupDashboard = async () => {
        let body = {
            "groupName": groupName
        }

        const response = await getDashboardStatsByGroup(apiData, body, dispatch)
        setGroupDashboardStats(response.data[0][0])
        setHasIons(response.data[0][0].controllerCount > 0)
        setHasLocks(response.data[0][0].lockCount > 0)
        setHasKeyboxes(response.data[0][0].keyboxCount > 0)
        setHasGateways(response.data[0][0].gatewayCount > 0)
        setHasSensors(response.data[0][0].sensorCount > 0)
        setHasCCTV(response.data[0][0].totalIntegrations > 0)

        console.log(response.data[0][0]);

        console.log(response.data[0][0].gatewayCount > 0);

        setBillableSensorCount(response.data[0][0].billedBLESensorCount + response.data[0][0].billedNBIOTSensorCount)
    }

    const HandleGetGroupRTDashboard = async () => {
        let body = { "groupName": groupName }
        const response = await getRTDashboardStatsByGroup(apiData, body, dispatch)
        setGroupRTDashboardStats(response.data[0][0])
        setIsLoadingRT(false)
        setLastRTUpdate(Date.now())
    }

    useEffect(() => {
        if (activeTab !== 1) return;
        const HandleGetTopUserStats = async () => {
            setIsLoadingUsers(true);
            const response = await getSiteAnalytics(apiDataRef.current, {
                groupName: groupName,
                start_date: selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90,
                end_date: null,
                analyticsType: "users",
                hasPortalUsers: portalFilter === "Exclude Portal Users" ? 1 : 0
            }, dispatch);

            console.log(response);
            setTopUserStats(response.data?.[0]?.topUsers || []);
            setIsLoadingUsers(false);
        };
        HandleGetTopUserStats();
    }, [selectedTime, activeTab, portalFilter]);

    useEffect(() => {
        if (activeTab !== 2) return;

        const bothNull = !selectedStartDate && !selectedEndDate;
        const bothSet = selectedStartDate && selectedEndDate;

        if (!bothNull && !bothSet) return; 

        const HandleGetAllUsers = async () => {
            setIsLoadingUsers(true);
            const response = await getSiteAnalytics(apiDataRef.current, {
                groupName: groupName,
                start_date: bothSet ? selectedStartDate : last8Years,
                end_date: bothSet ? selectedEndDate : now,
                analyticsType: "users",
                hasPortalUsers: portalFilter === "Exclude Portal Users" ? 1 : 0

            }, dispatch);
            setAllUserStats(response.data?.[0]?.allUsers || []);
            setIsLoadingUsers(false);
        };
        HandleGetAllUsers();
    }, [activeTab, selectedStartDate, selectedEndDate]);
    


    useEffect(() => {
        HandleGetGroupDashboard()
        //HandleGetRTScheduleStats()
        HandleGetGroupRTDashboard()
        const pollInterval = setInterval(HandleGetGroupRTDashboard, 60000)
        return () => clearInterval(pollInterval)
    }, []);

    useEffect(() => {
        if (!lastRTUpdate) return;
        setSecondsAgo(0);
        const tick = setInterval(() => setSecondsAgo(Math.floor((Date.now() - lastRTUpdate) / 1000)), 1000);
        return () => clearInterval(tick);
    }, [lastRTUpdate]);

    const formatSecondsAgo = (s) => s < 60 ? `${s}s ago` : `${Math.floor(s / 60)}m ${s % 60}s ago`;

    /*useEffect(() => {
        const currentRequestId = ++scheduleRequestId.current;
        setIsLoadingScheduleStats(true);
        const FetchScheduleStats = async () => {
            const response = await getSiteAnalytics(apiData, {
                siteUUID: "",
                groupName: groupName || localStorage.getItem('companyName'),
                integration_type: selectedIntegration == "All" ? "" : selectedIntegration?.toUpperCase() || "" ,
                rangeType: selectedTime.toLowerCase(),
                analyticsType: "schedules"
            }, dispatch);
            if (currentRequestId !== scheduleRequestId.current) return;
            setScheduleStats(response.data[0]);
            setIsLoadingScheduleStats(false);
        };
        FetchScheduleStats();
    }, [selectedTime, selectedIntegration]); */

    useEffect(() => {
        if (portalUsersUpdate === 0) return
        const refetch = async () => {
            try {
                const response = await getGroupUsers(apiData, groupID, dispatch)
                setPortalUsers(response?.data ?? [])
            } catch {
                setPortalUsers([])
            }
        }
        refetch()
    }, [portalUsersUpdate])

    const addSites = () => {
        dataManager.setItem('isGroupMode', true);
        navigate('/Dashboard/AllSites/');
    }

    const transferSites = async () => {
       
        let body = {
            groupID: selectedGroup.id,
            groupName: selectedGroup.name,
            groupDevices: dataManager.selectedSites.value,
        }

        const response = await addSitesToGroup(apiData, body, dispatch);
        if (response.success) {
            setRemoveVisible(false)
            setSuccessVisible(true)
            dataManager.setItem('isGroupMode', false);
            dataManager.setSelectedSites([]);
            setGroupMode(false);
            HandleGetGroupDashboard();
            setSubmit(prev => !prev);
        } else {
            setFailVisible(true)
        }
        
    }

    const editSites = () => {
        dataManager.setItem('isGroupMode', !groupMode);
        setGroupMode(!groupMode);

        if (buttonText == "Choose group") {
            setRemoveVisible(true)
        }
    }

    useEffect(() => {
        if (groupMode) {
            if (dataManager.getItem('selectedSites').length > 0) {
                setButtonText('Choose group')
            } else {
                setButtonText('Cancel')
            }
        } else {
            setButtonText('Edit sites')
        }
    }, [groupMode, checkedItems])

    const viewUsers = async () => {
        setPortalUsersVisible(true)
        setPortalUsersLoading(true)
        try {
            const response = await getGroupUsers(apiData, groupID, dispatch)
            setPortalUsers(response?.data ?? [])
        } catch {
            setPortalUsers([])
        } finally {
            setPortalUsersLoading(false)
        }
    }

    const handleUpdateCustomerNumber = async () => {
        const body = {
            groupID: groupID,
            customerNumber: customerNumber
        }

        const response = await updateCustomerNumber(apiData, body, dispatch)
        if (response.success){

            setGroupObject((prevGroupObj) => ({
                ...prevGroupObj,
                customerNumber: customerNumber,
            }));

            setSuccessVisible(true)

        } else {
            setFailVisible(true)
        }
    }

    const saveNewPermissions = async () => {
        const changes = [
            { column: "supportEnabled",      value: pEnableSupport       ? 1 : 0, original: groupObject?.supportEnabled },
            { column: "allowSiteCreation",   value: pAllowSiteCreation   ? 1 : 0, original: groupObject?.allowSiteCreation },
            { column: "billingEnabled",      value: pBillingApproved     ? 1 : 0, original: groupObject?.billingEnabled },
            { column: "allowGroupCreation",  value: pEnableGroupCreation ? 1 : 0, original: groupObject?.allowGroupCreation },
            { column: "accountApproved",     value: pAccountApproved     ? 1 : 0, original: groupObject?.accountApproved },
            { column: "isOnDD",              value: pIsOnDD              ? 1 : 0, original: groupObject?.isOnDD },
        ].filter(c => (c.value ? 1 : 0) !== (c.original ? 1 : 0));

        if (changes.length === 0) {
            setPermissionsVisible(false);
            return;
        }

        const results = await Promise.all(
            changes.map(({ column, value }) =>
                editGroupDetails(apiData, { "groupID": groupID, "columnName": column, "newValue": value }, dispatch)
            )
        );

        setPermissionsVisible(false);

        if (results.every(r => r.success)) {
            const patch = Object.fromEntries(changes.map(c => [c.column, c.value]));
            setGroupObject(prev => ({ ...prev, ...patch }));
            setSuccessVisible(true);
            getGroups(apiData, dispatch)
        } else {
            setFailVisible(true);
        }
    }

    const billingLineItems = [
        { key: 'site',         label: 'Site cost',                qty: groupDashboardStats?.activeBillableCount  ?? 0 },
        { key: 'cctvSite',     label: 'CCTV site cost',           qty: groupDashboardStats?.sitesWithCCTV        ?? 0 },
        { key: 'scheduleOnly', label: 'Schedule only site cost',  qty: groupDashboardStats?.scheduleOnlyCount    ?? 0 },
        { key: 'liveView',     label: 'Live view site cost',      qty: groupDashboardStats?.liveViewSitesCount   ?? 0 },
        { key: 'padlock',      label: 'Padlock cost',             qty: groupDashboardStats?.billedLockCount      ?? 0 },
        { key: 'keybox',       label: 'Keybox cost',              qty: groupDashboardStats?.billedKeyboxCount    ?? 0 },
        { key: 'sensor',       label: 'Sensor cost',              qty: billableSensorCount                       ?? 0 },
        { key: 'user',         label: 'User cost',                qty: groupDashboardStats?.activeTotalUserCount ?? 0 },
        { key: 'gateway',      label: 'Gateway cost',             qty: groupDashboardStats?.billedGatewayCount   ?? 0 },
    ];

    const generateBillingReport = () => {
        const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const { fromName, fromAddress, fromPhone, fromEmail, toName, toAddress, toCustomerNumber, invoiceNumber, invoiceDate, dueDate, notes } = invoiceDetails;
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();
        const margin = 18;

        // Header bar
        doc.setFillColor(28, 37, 54);
        doc.rect(0, 0, pageW, 36, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.text(fromName || 'Your Company', margin, 14);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(180, 195, 220);
        doc.text('INVOICE', pageW - margin, 14, { align: 'right' });

        // From / invoice meta
        doc.setFontSize(8.5);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(70, 70, 70);
        let leftY = 46;
        const addLeft = (text) => { if (text) { doc.text(text, margin, leftY); leftY += 5; } };
        addLeft(fromAddress);
        addLeft(fromPhone ? `Tel: ${fromPhone}` : null);
        addLeft(fromEmail ? `Email: ${fromEmail}` : null);

        const rightX = pageW - margin;
        let rightY = 46;
        const addRight = (label, value) => {
            if (!value) return;
            doc.setFont('helvetica', 'bold');
            doc.text(`${label}:`, rightX - 28, rightY, { align: 'right' });
            doc.setFont('helvetica', 'normal');
            doc.text(String(value), rightX, rightY, { align: 'right' });
            rightY += 5;
        };
        addRight('Invoice #', invoiceNumber);
        addRight('Date', invoiceDate);
        addRight('Due', dueDate);

        // Bill To box
        const billToY = Math.max(leftY, rightY) + 8;
        doc.setFillColor(246, 247, 249);
        doc.rect(margin, billToY, pageW - margin * 2, 34, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7.5);
        doc.setTextColor(130, 130, 130);
        doc.text('BILL TO', margin + 5, billToY + 8);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.setTextColor(30, 30, 30);
        doc.text(toName || '', margin + 5, billToY + 16);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8.5);
        doc.setTextColor(70, 70, 70);
        let billInfoY = billToY + 22;
        if (toAddress) { doc.text(toAddress, margin + 5, billInfoY); billInfoY += 5; }
        if (toCustomerNumber) { doc.text(`Customer #: ${toCustomerNumber}`, margin + 5, billInfoY); }

        // Line items table
        const tableStartY = billToY + 42;
        const lineItems = billingLineItems
            .map(({ key, label, qty }) => {
                const cost = parseFloat(billingCosts[key]) || 0;
                return { label, qty, cost, total: qty * cost };
            })
            .filter(({ qty, cost }) => qty > 0 || cost > 0);
        const grandTotal = lineItems.reduce((sum, { total }) => sum + total, 0);

        autoTable(doc, {
            startY: tableStartY,
            margin: { left: margin, right: margin },
            head: [['Description', 'Qty', 'Unit Price', 'Amount']],
            body: lineItems.map(({ label, qty, cost, total }) => [
                label, qty, `£${cost.toFixed(2)}`, `£${total.toFixed(2)}`
            ]),
            headStyles: { fillColor: [28, 37, 54], textColor: [255, 255, 255], fontSize: 9, fontStyle: 'bold' },
            bodyStyles: { fontSize: 9, textColor: [50, 50, 50] },
            alternateRowStyles: { fillColor: [249, 250, 251] },
            columnStyles: {
                0: { cellWidth: 'auto' },
                1: { halign: 'center', cellWidth: 18 },
                2: { halign: 'right', cellWidth: 28 },
                3: { halign: 'right', cellWidth: 28 },
            },
            styles: { cellPadding: 4 },
        });

        let curY = (doc.lastAutoTable?.finalY ?? tableStartY + 40) + 8;

        // Total
        doc.setDrawColor(210, 210, 210);
        doc.line(pageW - margin - 60, curY, pageW - margin, curY);
        curY += 6;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(28, 37, 54);
        doc.text('Total:', pageW - margin - 30, curY, { align: 'right' });
        doc.text(`£${grandTotal.toFixed(2)}`, pageW - margin, curY, { align: 'right' });
        curY += 12;

        // Notes
        if (notes) {
            doc.setDrawColor(225, 225, 225);
            doc.line(margin, curY - 2, pageW - margin, curY - 2);
            curY += 5;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(120, 120, 120);
            doc.text('NOTES / PAYMENT TERMS', margin, curY);
            curY += 5;
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8.5);
            doc.setTextColor(60, 60, 60);
            doc.text(doc.splitTextToSize(notes, pageW - margin * 2), margin, curY);
        }

        // Footer bar
        doc.setFillColor(28, 37, 54);
        doc.rect(0, pageH - 18, pageW, 18, 'F');
        doc.setTextColor(180, 195, 220);
        doc.setFontSize(7.5);
        doc.setFont('helvetica', 'normal');
        const footerText = [fromEmail, fromPhone].filter(Boolean).join('   |   ');
        if (footerText) doc.text(footerText, pageW / 2, pageH - 8, { align: 'center' });

        const filename = `invoice-${(toName || groupName).replace(/\s+/g, '-').toLowerCase()}-${new Date().toISOString().split('T')[0]}.pdf`;
        doc.save(filename);
    };

    return (
        <>
            <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

           <Dialog
                header="Remove sites"
                visible={removeVisible}
                style={{ width: "40vw" }}
                onHide={() => setRemoveVisible(false)}
                >
                <div>
                    <p>Choose the new group from the dropdown below</p>
                    <Dropdown
                        value={selectedGroup}
                        className="w-full md:w-14rem"
                        style={{ width: '400px' }}
                        onChange={(e) => setSelectedGroup(e.value)}  // e.value is FULL group object
                        options={groups}
                        optionLabel="name"
                        placeholder="Choose group"
                        showClear
                        filter
                        filterPlaceholder="Search groups..."
                    />

    
                </div>
    
                <br></br>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button  icon="pi pi-ban" label="Remove sites" severity="danger" disabled={!selectedGroup} onClick={transferSites} />
                </div>
            </Dialog>

            <Dialog
                header="Success"
                visible={successVisible}
                style={{ width: "40vw" }}
                onHide={() => setSuccessVisible(false)}
                >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3 style={{color:"#6e6e6eff"}}>Action completed successfully!</h3>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />

                    <Button  label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
                </div>
            </Dialog>

            <Dialog
                header="Something went wrong"
                visible={failVisible}
                style={{ width: "40vw" }}
                onHide={() => setFailVisible(false)}
                >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br/>
                    <h3 style={{color:"#6e6e6eff"}}>Something went wrong, please try again</h3>
                    <br></br>
                    <Button icon="pi pi-times" label="Okay" severity="secondary" onClick={() => setFailVisible(false)}/>
                    <br/>
                    <Button label="Create user?" icon="pi pi-info-circle" severity="secondary" onClick={() => { setFailVisible(false); setGivePortalAccessVisible(false); setCreateUserVisible(true); }}/>
                </div>
            </Dialog>

            <Dialog
                header="Give Portal access"
                visible={givePortalAccessVisible}
                style={{ width: "40vw" }}
                onHide={() => setGivePortalAccessVisible(false)}
            >
                <div className="flex gap-4">
                    <AddPortalUser setSuccess={setSuccessVisible} setFail={setFailVisible} groupID={groupID} setShowPrevDialogs={setGivePortalAccessVisible} />
                </div>
            </Dialog>

            <Dialog
                header="Give Portal access"
                visible={createUserVisible}
                style={{ width: "40vw" }}
                onHide={() => setCreateUserVisible(false)}
            >
                <div className="flex gap-4">
                    <CreateUserPortal setSuccessVisible={setSuccessVisible} setFailVisible={setFailVisible} setCreateAccountVisible={setCreateUserVisible} groupID={groupID} />
                </div>
            </Dialog>

            <Dialog
                header={`Portal users — ${groupName}`}
                visible={portalUsersVisible}
                style={{ width: "70vw" }}
                onHide={() => setPortalUsersVisible(false)}
            >
                <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "12px" }}>
                    <Button label="Give Portal access" icon="pi pi-user-plus" severity="success" onClick={() => setGivePortalAccessVisible(true)} />
                </div>
                {portalUsersLoading ? (
                    <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
                        <Oval stroke="#6e6e6e" />
                    </div>
                ) : Array.isArray(portalUsers) && portalUsers.length > 0 ? (
                    <UserList data={portalUsers} isGroup={true} update={portalUsersUpdate} setUpdate={setPortalUsersUpdate} isPortalUsers={true} />
                ) : (
                    <p style={{ textAlign: "center", color: "#9e9e9e", padding: "40px 0" }}>No portal users found for this group.</p>
                )}
            </Dialog>


            <Dialog
                header={`Group permissions — ${groupName}`}
                visible={permissionsVisible}
                style={{ width: "420px" }}
                onHide={() => setPermissionsVisible(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    {permissionItems.map(({ id, label, checked, set }) => (
                        <div key={id} style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                            <Checkbox inputId={id} checked={checked} onChange={e => set(e.checked)} />
                            <label htmlFor={id} style={{ fontSize: "14px", color: "#4a4a4a", cursor: "pointer", userSelect: "none" }}>{label}</label>
                        </div>
                    ))}
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "4px", borderTop: "1px solid #f0f0f0", paddingTop: "16px" }}>
                        <Button label="Cancel" icon="pi pi-times" severity="secondary" onClick={() => setPermissionsVisible(false)} />
                        <Button label="Save" icon="pi pi-save" onClick={() => saveNewPermissions()} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set customer number"
                visible={changeCustomerNumber}
                style={{ width: "40vw" }}
                onHide={() => setChangeCustomerNumber(false)}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                        width: "100%"
                    }}
                >
                    <div style={{ width: "100%" }}>
                        <label htmlFor="customerNumber" style={{ display: "block", marginBottom: "8px" }}>
                            Customer Number
                        </label>
                        <InputText
                            id="customerNumber"
                            value={customerNumber}
                            onChange={(e) => setCustomerNumber(e.target.value)}
                            placeholder="Enter customer number"
                            style={{ width: "100%" }}
                        />
                    </div>

                    <div style={{ display: "flex", gap: "10px" }}>
                        <Button
                            label="Cancel"
                             icon="pi pi-times"
                            severity="secondary"
                            onClick={() => setChangeCustomerNumber(false)}
                        />
                        <Button
                            label="Save"
                            icon="pi pi-save"
                            onClick={() => {
                                handleUpdateCustomerNumber()
                                setChangeCustomerNumber(false);
                            }}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header={`Generate billing report — ${groupName}`}
                visible={billingReportVisible}
                style={{ width: "720px" }}
                onHide={() => setBillingReportVisible(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                    {/* From / Bill To */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#444" }}>From</p>
                            <InputText placeholder="Company name" value={invoiceDetails.fromName} onChange={e => setInvoiceDetails(p => ({ ...p, fromName: e.target.value }))} style={{ fontSize: "13px" }} />
                            <InputText placeholder="Address" value={invoiceDetails.fromAddress} onChange={e => setInvoiceDetails(p => ({ ...p, fromAddress: e.target.value }))} style={{ fontSize: "13px" }} />
                            <InputText placeholder="Phone" value={invoiceDetails.fromPhone} onChange={e => setInvoiceDetails(p => ({ ...p, fromPhone: e.target.value }))} style={{ fontSize: "13px" }} />
                            <InputText placeholder="Email" value={invoiceDetails.fromEmail} onChange={e => setInvoiceDetails(p => ({ ...p, fromEmail: e.target.value }))} style={{ fontSize: "13px" }} />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#444" }}>Bill to</p>
                            <InputText placeholder="Client / company name" value={invoiceDetails.toName} onChange={e => setInvoiceDetails(p => ({ ...p, toName: e.target.value }))} style={{ fontSize: "13px" }} />
                            <InputText placeholder="Address" value={invoiceDetails.toAddress} onChange={e => setInvoiceDetails(p => ({ ...p, toAddress: e.target.value }))} style={{ fontSize: "13px" }} />
                            <InputText placeholder="Customer number" value={invoiceDetails.toCustomerNumber} onChange={e => setInvoiceDetails(p => ({ ...p, toCustomerNumber: e.target.value }))} style={{ fontSize: "13px" }} />
                        </div>
                    </div>

                    {/* Invoice metadata */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
                        <div>
                            <label style={{ display: "block", fontSize: "12px", color: "#777", marginBottom: "4px" }}>Invoice number</label>
                            <InputText value={invoiceDetails.invoiceNumber} onChange={e => setInvoiceDetails(p => ({ ...p, invoiceNumber: e.target.value }))} style={{ width: "100%", fontSize: "13px" }} />
                        </div>
                        <div>
                            <label style={{ display: "block", fontSize: "12px", color: "#777", marginBottom: "4px" }}>Invoice date</label>
                            <InputText value={invoiceDetails.invoiceDate} onChange={e => setInvoiceDetails(p => ({ ...p, invoiceDate: e.target.value }))} style={{ width: "100%", fontSize: "13px" }} />
                        </div>
                        <div>
                            <label style={{ display: "block", fontSize: "12px", color: "#777", marginBottom: "4px" }}>Due date</label>
                            <InputText value={invoiceDetails.dueDate} onChange={e => setInvoiceDetails(p => ({ ...p, dueDate: e.target.value }))} placeholder="e.g. 20/06/2026" style={{ width: "100%", fontSize: "13px" }} />
                        </div>
                    </div>

                    <div style={{ borderTop: "1px solid #ececec" }} />

                    {/* Line items */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 60px 130px 90px", gap: "8px", fontWeight: "600", color: "#555", fontSize: "13px", borderBottom: "1px solid #e0e0e0", paddingBottom: "10px", marginBottom: "4px" }}>
                            <span>Item</span>
                            <span style={{ textAlign: "center" }}>Qty</span>
                            <span style={{ textAlign: "center" }}>Unit price (£)</span>
                            <span style={{ textAlign: "right" }}>Total</span>
                        </div>

                        {billingLineItems.map(({ key, label, qty }) => {
                            const lineTotal = qty * (parseFloat(billingCosts[key]) || 0);
                            return (
                                <div key={key} style={{ display: "grid", gridTemplateColumns: "1fr 60px 130px 90px", gap: "8px", alignItems: "center", padding: "7px 0", borderBottom: "1px solid #f4f4f4" }}>
                                    <span style={{ fontSize: "14px", color: "#333" }}>{label}</span>
                                    <span style={{ textAlign: "center", fontSize: "14px", color: "#666" }}>{qty}</span>
                                    <InputText
                                        value={billingCosts[key]}
                                        onChange={(e) => setBillingCosts(prev => ({ ...prev, [key]: e.target.value }))}
                                        placeholder="0.00"
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        style={{ width: "100%", textAlign: "right", fontSize: "14px", padding: "6px 8px" }}
                                    />
                                    <span style={{ textAlign: "right", fontSize: "14px", color: "#333" }}>
                                        £{lineTotal.toFixed(2)}
                                    </span>
                                </div>
                            );
                        })}

                        <div style={{ display: "flex", justifyContent: "flex-end", borderTop: "2px solid #e0e0e0", paddingTop: "12px", marginTop: "8px" }}>
                            <span style={{ fontSize: "16px", fontWeight: "600", color: "#333" }}>
                                Total: £{billingLineItems.reduce((sum, { key, qty }) => sum + qty * (parseFloat(billingCosts[key]) || 0), 0).toFixed(2)}
                            </span>
                        </div>
                    </div>

                    {/* Notes */}
                    <div>
                        <label style={{ display: "block", fontSize: "12px", color: "#777", marginBottom: "4px" }}>Notes / payment terms</label>
                        <InputTextarea
                            value={invoiceDetails.notes}
                            onChange={e => setInvoiceDetails(p => ({ ...p, notes: e.target.value }))}
                            placeholder="e.g. Payment due within 30 days. Bank transfer to..."
                            rows={3}
                            style={{ width: "100%", fontSize: "13px", resize: "vertical" }}
                        />
                    </div>

                    {/* Generate */}
                    <div style={{ display: "flex", justifyContent: "flex-end", borderTop: "1px solid #ececec", paddingTop: "16px" }}>
                        <Button label="Generate PDF invoice" icon="pi pi-file-pdf" onClick={generateBillingReport} />
                    </div>
                </div>
            </Dialog>

            <div className={classes['activtyPage_container']}>
                <div style={{ marginLeft: "3px", color: "#7f7f7f", display: "flex", alignItems: "center", gap: "8px" }}>
                    <div>
                        <h2 style={{ margin: 0 }}>{groupName}</h2>
                        <p style={{ margin: 0 }}>{groupPathToDisplay}</p>
                    </div>
                    {role === "admin" && permissionItems.length > 0 && (
                        <Button
                            icon="pi pi-cog"
                            rounded
                            text
                            severity="secondary"
                            onClick={() => setPermissionsVisible(true)}
                            tooltip="Group permissions"
                            tooltipOptions={{ position: "right" }}
                            style={{ color: "#a0a0a0" }}
                        />
                    )}
                </div>
<br/>
                {isAllowed && groupDashboardStats && (
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <Stats2 title={"Customer number"} value={groupObject.customerNumber != null ? groupObject.customerNumber : "Not set"} isLoadingStats={false} isStatic={true} editable={true} setChangeCustomerNumber={setChangeCustomerNumber} />
                        <Button label="Generate billing report" icon="pi pi-file" onClick={() => setBillingReportVisible(true)} />
                    </div>
                )}
<br/>
                <div className={classes.tabsWrapper}>
                    <div className={classes.tabs}>
                        {["Sites", "Overview", "All users"].map((tab, i) => (
                            <button
                                key={tab}
                                className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                                onClick={() => setActiveTab(i)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    <div className={classes.tabContent}>
                        {activeTab === 0 && !isGroupUsersPage && (
                            <>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    {groupSites &&
                                        <>
                                            <GroupSitesSearchBar
                                                type="text"
                                                placeholder="Search..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                showFilterButton={true}
                                                groups={[]}
                                                includeSubgroups={includeSubgroups}
                                                setIncludeSubgroups={setIncludeSubgroups}
                                                online={online}
                                                setOnline={setOnline}
                                                offline={offline}
                                                setOffline={setOffline}
                                                deviceTag={deviceTag}
                                                setDeviceTag={setDeviceTag}
                                                cloudController={cloudController}
                                                setCloudController={setCloudController}
                                                davantis={davantis}
                                                setDavantis={setDavantis}
                                                G2CC={g2cc}
                                                setG2CC={setG2cc}
                                                ESP={ESP}
                                                setESP={setESP}
                                                RPi={RPi}
                                                setRPi={setRPi}
                                                groupName={groupName2}
                                                setGroupName={setGroupName2}
                                                submit={submit}
                                                setSubmit={setSubmit}
                                                noTag={noTag}
                                                setNoTag={setNoTag}
                                                noUsers={noUsers}
                                                setNoUsers={setNoUsers}
                                                liveViewStatus={liveViewStatus}
                                                setLiveViewStatus={setLiveViewStatus}
                                                hasAjax={hasAjax}
                                                setHasAjax={setHasAjax}
                                                hasHik={hasHik}
                                                setHasHik={setHasHik}
                                                hasAIBOX={hasAIBOX}
                                                setHasAIBOX={setHasAIBOX}
                                                hasDahua={hasDahua}
                                                setHasDahua={setHasDahua}
                                                active={active}
                                                setActive={setActive}
                                                hasPadlock={hasPadlock}
                                                setHasPadlock={setHasPadlock}
                                                hasKeybox={hasKeybox}
                                                setHasKeybox={setHasKeybox}
                                                hasGateway={hasGateway}
                                                setHasGateway={setHasGateway}
                                                hasSigfox={hasSigfox}
                                                setHasSigfox={setHasSigfox}
                                                hasIndSigfox={hasIndSigfox}
                                                setHasIndSigfox={setHasIndSigfox}
                                                hasEfento={hasEfento}
                                                setHasEfento={setHasEfento}
                                                hasTeltonika={hasTeltonika}
                                                setHasTeltonika={setHasTeltonika}
                                                hasSchedule={hasSchedules}
                                                setHasSchedule={setHasSchedules}
                                                hasTempSchedules={hasTempSchedules}
                                                setHasTempSchedules={setHasTempSchedules}
                                                scheduleOnly={scheduleOnly}
                                                setScheduleOnly={setScheduleOnly}
                                                activePinCount={activePinCount}
                                                setActivePinCount={setActivePinCount}
                                                sortAsc={sortAsc}
                                                setSortAsc={setSortAsc}
                                                sUserCount={sUserCount}
                                                setSUserCount={setSUserCount}
                                                sCreated={sCreated}
                                                setSCreated={setSCreated}
                                                sFirmware={sFirmware}
                                                setSFirmware={setSFirmware}
                                                sName={sName}
                                                setSName={setSName}
                                                sCameraCount={sCameraCount}
                                                setSCameraCount={setSCameraCount}
                                                ruleV2Owner={ruleV2Owner}
                                                setRuleV2Owner={setRuleV2Owner}
                                                ruleV2Parent={ruleV2Parent}
                                                setRuleV2Parent={setRuleV2Parent}
                                                ruleV2Affected={ruleV2Affected}
                                                setRuleV2Affected={setRuleV2Affected}
                                                isGroupSites={true}
                                                connectionIssues={connectionIssues}
                                                setConnectionIssues={setConnectionIssues}
                                                hasCamerasLinked={hasCamerasLinked}
                                                setHasCamerasLinked={setHasCamerasLinked}
                                                billable={billable}
                                                setBillable={setBillable}
                                                billingFrequency={billingFrequency}
                                                setBillingFrequency={setBillingFrequency}
                                                billedTo={billedTo}
                                                setBilledTo={setBilledTo}
                                                sDateOfSale={sDateOfSale}
                                                setSDateOfSale={setSDateOfSale}
                                                sLastInvoice={sLastInvoice}
                                                setSLastInvoice={setSLastInvoice}
                                                sDateMadeActive={sDateMadeActive}
                                                setSDateMadeActive={setSDateMadeActive}
                                                style={{
                                                    padding: "10px",
                                                    width: "300px",
                                                    fontSize: "14px",
                                                    boxSizing: "border-box",
                                                    borderRadius: "4px",
                                                }}
                                            />

                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <Button severity='success' label="Add sites" onClick={addSites} icon="pi pi-plus" style={{ fontSize: "14px", padding: 10 }} />
                                                <Button severity='danger' label={buttonText} onClick={editSites} icon="pi pi-times" style={{ fontSize: "14px", padding: 10 }} />
                                                <Button severity="info" label="View portal users" icon="pi pi-user" onClick={viewUsers} style={{ fontSize: "14px", padding: 10 }} />
                                            </div>
                                        </>
                                    }
                                </div>

                                <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                                    <p>Total results: {resultCount}</p>
                                </div>

                                <Await resolve={filteredData}>
                                    {(loadedFilteredData) => (
                                        <div style={{ display: "flex", width: "100%", height: "100%" }}>
                                            {isLoadingSites ? (
                                                <div style={{ display: "flex", width: "100%" }}>
                                                    <DeviceLoadingGrid CardCount={20} />
                                                </div>
                                            ) : (
                                                <DevicesList
                                                    devices={loadedFilteredData}
                                                    filtering={""}
                                                    hideControls={false}
                                                    totalPages={totalPages}
                                                    setTotalPages={setTotalPages}
                                                    pageFetchedIndex={pageFetchedIndex}
                                                    setPageFetchedIndex={setPageFetchedIndex}
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalDevices={resultCount}
                                                    setTotalDevices={setTotalDevices}
                                                    groupMode={groupMode}
                                                    update={update}
                                                    setUpdate={setUpdate}
                                                    offlineOnly={false}
                                                    isSortable={true}
                                                    showMassSelect={true}
                                                    showMassSettings={showMassSettings}
                                                    setShowMassSettings={setShowMassSettings}
                                                    isGroupSites={true}
                                                />
                                            )}
                                        </div>
                                    )}
                                </Await>
                            </>
                        )}

                        {activeTab === 1 && (
                            <>
                            
                                <br/>
                                <div>
                                    <p className={classes.sectionTitle}>Portfolio overview</p>
                                    <div className={classes.portfolioGrid}>
                                        {groupDashboardStats ? <>
                                            <StatCard title={"All sites"} value={groupDashboardStats.sitesCount} />
                                            <StatCard title={"Active sites"} value={groupDashboardStats.activeCount} />
                                            <StatCard title={"Inactive sites"} value={groupDashboardStats.inactiveCount} />
                                            <StatCard title={"Sites on schedule"} value={groupDashboardStats.scheduleCount} hasSecondValue={true} value2={groupDashboardStats.activeScheduleCount} />
                                            <StatCard title={"Active schedule only sites"} value={groupDashboardStats.scheduleOnlyCount} />
                                            <StatCard title={"Live view enabled sites"} value={groupDashboardStats.liveViewSitesCount} />
                                            <StatCard title={"Users"} value={groupDashboardStats.totalUserCount} hasSecondValue={true} value2={groupDashboardStats.activeTotalUserCount} />
                                            <StatCard title={"Groups"} value={groupDashboardStats.accountsCount} />
                                        </> : [...Array(7)].map((_, i) => <GsSkeletonCard key={i} />)}
                                    </div>
                                </div>
<br/>
{/* <br/>
                                  {hasGateways && <GsRTSectionHeader title="Gateway health" lastRTUpdate={lastRTUpdate} secondsAgo={secondsAgo} formatSecondsAgo={formatSecondsAgo} />}
                                  <br/>
                                   <div className={classes.container}>
                                    {groupDashboardStats && <>
                                        {hasGateways && <StatCard title={"Gateways"} value={groupDashboardStats.gatewayCount} hasSecondValue={true} value2={groupDashboardStats.activeGatewayCount} />} 
                                    </>}
                                </div>
                                <br/>
                                {hasGateways && <div className={classes.chartsGrid}>
                                    {isLoadingRT ? [...Array(2)].map((_, i) => <GsSkeletonChart key={i} />) : groupRTDashboardStats && <>
                                        <GsDonutCard title="Padlock battery health" labels={["Critical (<5%)", "Warning (<20%)", "Healthy (>20%)"]} values={[groupRTDashboardStats.criticalLocks, groupRTDashboardStats.warningLocks, groupRTDashboardStats.healthyLocks]} colors={[C.critical, C.warning, C.healthy]} />
                                        <GsDonutCard title="Keybox battery health" labels={["Critical (<5%)", "Warning (<20%)", "Healthy (>20%)"]} values={[groupRTDashboardStats.criticalKeyboxes, groupRTDashboardStats.warningKeyboxes, groupRTDashboardStats.healthyKeyboxes]} colors={[C.critical, C.warning, C.healthy]} />
                                    </>}
                                </div>} */}
                                <br/>

                                <SectionHeaderTime title="User Stats" times={times} selectedTime={selectedTime} setSelectedTime={setSelectedTime} portalFilter={portalFilter} setPortalFilter={setPortalFilter} />
                                <br />

                                {isLoadingUsers ? <> <GsSkeletonBarChart /> <br /> <GsSkeletonTableCard /> </> : topUserStats && topUserStats.length > 0 ? (
                                    <>
                                    <GsBarCard
                                        title="Top 10 users by output actions"
                                        labels={topUserStats.slice(0,10).map(u => u.fullName)}
                                        values={topUserStats.slice(0,10).map(u => u.total_actions)}
                                        colors={["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e", "#1eb9c7"]}
                                        topUserData={topUserStats}
                                        onUserClick={handleUserClick}
                                    />
                                    <br />
                                    {topUserStats.length > 10 &&
                                        <GsTableCard
                                            title="Top 50 users by output actions"
                                            topUserData={topUserStats}
                                            onUserClick={handleUserClick}
                                        />
                                    }
                                    </>
                                ) : (
                                    <p style={{ textAlign: "center", color: "#888888", marginTop: "2rem" }}>No user activity data available for this time period.</p>
                                )}
                                <br />

                                {hasGateways && <>
                                <GsRTSectionHeader title="Gateway health" lastRTUpdate={lastRTUpdate} secondsAgo={secondsAgo} formatSecondsAgo={formatSecondsAgo} />
                                <div className={classes.container}>
                                    {groupDashboardStats && <>
                                        {hasGateways && <StatCard title={"Gateways"} value={groupDashboardStats.gatewayCount} hasSecondValue={true} value2={groupDashboardStats.activeGatewayCount} />} 
                                    </>}
                                </div>
                                <br/>
                                <div className={classes.chartsGrid}>
                                    {isLoadingRT ? [...Array(4)].map((_, i) => <GsSkeletonChart key={i} />) : groupRTDashboardStats && <>
                                        <GsDonutCard title="Connectivity status" labels={["Online", "Missed 1 poll", "Offline", "Power down", "Unknown"]} values={[groupRTDashboardStats.onlineGateways, groupRTDashboardStats.potentiallyStaleGateways, groupRTDashboardStats.staleGateways, groupRTDashboardStats.powerDownGateways, groupRTDashboardStats.unknownGateways]} colors={[C.online, C.missed1poll, C.offline, C.powerDown, C.unknown]} />
                                        <GsDonutCard title="Battery health" labels={["Critical (<5%)", "Warning (<20%)", "Healthy (>20%)"]} values={[groupRTDashboardStats.criticalGateways, groupRTDashboardStats.warningGateways, groupRTDashboardStats.healthyGateways]} colors={[C.critical, C.warning, C.healthy]} />
                                        <GsDonutCard title="Power source" labels={["Mains", "Solar", "Battery"]} values={[groupRTDashboardStats.mainsPoweredGateways, groupRTDashboardStats.solarPoweredGateways, groupRTDashboardStats.batteryPoweredGateways]} colors={[C.mains, C.solar, C.battery]} />
                                        <GsDonutCard title="Signal quality" labels={["Poor", "Fair", "Good"]} values={[groupRTDashboardStats.poorSignalGateways, groupRTDashboardStats.fairSignalGateways, groupRTDashboardStats.goodSignalGateways]} colors={[C.poor, C.fair, C.good]} />
                                    </>}
                                </div>
                                </>}

                               <br/>
                                <br/>
                                {(hasLocks || hasGateways || hasSensors || hasGateways) && <GsRTSectionHeader title="Device health" lastRTUpdate={lastRTUpdate} secondsAgo={secondsAgo} formatSecondsAgo={formatSecondsAgo} />}
                                <br/>
                                <div className={classes.container}>
                                    {groupDashboardStats && <>
                                        {hasLocks && <StatCard title={"Padlocks"} value={groupDashboardStats.lockCount} hasSecondValue={true} value2={groupDashboardStats.activeLockCount} />}
                                        {hasKeyboxes && <StatCard title={"Keyboxes"} value={groupDashboardStats.keyboxCount} hasSecondValue={true} value2={groupDashboardStats.activeKeyboxCount} />}
                                        {hasSensors && <StatCard title={"Sensors"} value={groupDashboardStats.sensorCount} hasSecondValue={true} value2={groupDashboardStats.activeSensorCount} />}
                                    </>}
                                </div>
                                <br/>
                                <div className={classes.chartsGrid}>
                                    {isLoadingRT ? [...Array(2)].map((_, i) => <GsSkeletonChart key={i} />) : groupRTDashboardStats && <>
                                        {hasLocks && <GsDonutCard title="Padlock battery health" labels={["Critical (<5%)", "Warning (<20%)", "Healthy (>20%)"]} values={[groupRTDashboardStats.criticalLocks, groupRTDashboardStats.warningLocks, groupRTDashboardStats.healthyLocks]} colors={[C.critical, C.warning, C.healthy]} />}
                                        {hasKeyboxes && <GsDonutCard title="Keybox battery health" labels={["Critical (<5%)", "Warning (<20%)", "Healthy (>20%)"]} values={[groupRTDashboardStats.criticalKeyboxes, groupRTDashboardStats.warningKeyboxes, groupRTDashboardStats.healthyKeyboxes]} colors={[C.critical, C.warning, C.healthy]} />}
                                    </>}
                                </div>
                                <br/>
                              
                                <br/>
                                {hasCCTV && <GsRTSectionHeader title="Linked CCTV Systems Connection Health" lastRTUpdate={lastRTUpdate} secondsAgo={secondsAgo} formatSecondsAgo={formatSecondsAgo} />}
                                <br/>
                                {hasCCTV && <div className={classes.container}>
                                    {groupDashboardStats && <>
                                        <StatCard title={"Total integrations"} value={groupDashboardStats.totalIntegrations} hasSecondValue={true} value2={groupDashboardStats.totalActiveIntegrations} />
                                        <StatCard title={"AJAX"} value={groupDashboardStats.ajaxCount} hasSecondValue={true} value2={groupDashboardStats.activeAjaxCount} />
                                        <StatCard title={"Dahua"} value={groupDashboardStats.dahuaCount} hasSecondValue={true} value2={groupDashboardStats.activeDahuaCount} />
                                        <StatCard title={"Hikvision"} value={groupDashboardStats.hikvisionCount} hasSecondValue={true} value2={groupDashboardStats.activeHikvisionCount} />
                                        <StatCard title={"AIBox"} value={groupDashboardStats.aiboxCount} hasSecondValue={true} value2={groupDashboardStats.activeAiboxCount} />
                                        {groupRTDashboardStats && <StatCard title={"Unstable CCTV connections"} value={groupDashboardStats.unstableCCTV} />}
                                    </>}
                                </div>}
<br/>
                                {hasCCTV && <CCTVAnalyticsGroup groupID={groupID} />}

                                {hasCCTV && groupRTDashboardStats && (
                                    <div className={classes.container}>
                                        <StatCard title={"Offline AJAX"} value={groupRTDashboardStats.offlineAJAX ?? 0} valueColor={(groupRTDashboardStats.offlineAJAX ?? 0) > 0 ? C.offline : C.healthy} onClick={() => navigate('/Dashboard/CCTVIntegrations', { state: { integrationType: 'AJAX', missedPollsFilter: 3, groupName } })} />
                                        <StatCard title={"Offline Dahua"} value={groupRTDashboardStats.offlineDahua ?? 0} valueColor={(groupRTDashboardStats.offlineDahua ?? 0) > 0 ? C.offline : C.healthy} onClick={() => navigate('/Dashboard/CCTVIntegrations', { state: { integrationType: 'DAHUA', missedPollsFilter: 3, groupName } })} />
                                        <StatCard title={"Offline Hikvision"} value={groupRTDashboardStats.offlineHik ?? 0} valueColor={(groupRTDashboardStats.offlineHik ?? 0) > 0 ? C.offline : C.healthy} onClick={() => navigate('/Dashboard/CCTVIntegrations', { state: { integrationType: 'HIKVISION', missedPollsFilter: 3, groupName } })} />
                                        <StatCard title={"Offline AIBox"} value={groupRTDashboardStats.offlineAibox ?? 0} valueColor={(groupRTDashboardStats.offlineAibox ?? 0) > 0 ? C.offline : C.healthy} onClick={() => navigate('/Dashboard/CCTVIntegrations', { state: { integrationType: 'AIBOX', missedPollsFilter: 3, groupName } })} />
                                    </div>
                                )}

                                <br/>
                                 {hasIons && <>
                                    <GsRTSectionHeader title="iON health" lastRTUpdate={lastRTUpdate} secondsAgo={secondsAgo} formatSecondsAgo={formatSecondsAgo} />
                                    <div className={classes.siteHealthRow}>
                                        <div className={classes.siteHealthDonut}>
                                            {isLoadingRT ? <GsSkeletonChart /> : groupRTDashboardStats &&
                                                <GsDonutCard title="Online vs offline" labels={["Online", "Offline"]} values={[groupRTDashboardStats.onlineSites, groupRTDashboardStats.offlineSites]} colors={[C.online, C.offline]} />
                                            }
                                        </div>
                                        <div className={classes.siteHealthStats}>
                                            {groupDashboardStats ? <>
                                                <StatCard title={"iON's"} value={groupDashboardStats.controllerCount} hasSecondValue={true} value2={groupDashboardStats.activeControllerCount} />
                                                <StatCard title={"Offline iON's"} value={groupDashboardStats.offlineCount} hasSecondValue={true} value2={groupDashboardStats.offlineActiveCount} />
                                            </> : [...Array(3)].map((_, i) => <GsSkeletonCard key={i} />)}
                                        </div>
                                    </div>
                                </>}
                                <br/>
                                <p className={classes.sectionTitle}>Billing</p>
                                <br />
                                <div className={classes.container}>
                                    {groupDashboardStats && (<>
                                        <StatCard title={"Billable sites"} value={groupDashboardStats.activeBillableCount} />
                                        {hasCCTV && <StatCard title={"CCTV sites"} value={groupDashboardStats.sitesWithCCTV} /> }
                                        {hasLocks && (<StatCard title={"Billable padlocks"} value={groupDashboardStats.billedLockCount} />)}
                                        {hasKeyboxes && (<StatCard title={"Billable keyboxes"} value={groupDashboardStats.billedKeyboxCount} />)}
                                        {hasGateways && (<StatCard title={"Billable gateways"} value={groupDashboardStats.billedGatewayCount} />)}
                                        {hasSensors && (<StatCard title={"Billable sensors"} value={billableSensorCount} />)}

                                    </>)}
                                </div>
                            </>
                        )}

                        {activeTab === 2 && (
                            <>
                                <div style={{ marginBottom: "16px", marginTop: "16px" }}>
                                    <p className={classes.filterLabel}>Filter by creation date</p>
                                    <div style={{ display: "flex", gap: "16px", alignItems: "center", marginTop: "8px" }}>
                                        <Calendar inputId="start_date" value={selectedStartDate} onChange={(e) => setSelectedStartDate(e.value)} dateFormat="yy-mm-dd" placeholder="From" />
                                        <span>—</span>
                                        <Calendar inputId="end_date" value={selectedEndDate} onChange={(e) => setSelectedEndDate(e.value)} dateFormat="yy-mm-dd" placeholder="To" />
                                        <img className={classes.clearButton} src={bin}
                                            onClick={() => {
                                                setSelectedStartDate(null);
                                                setSelectedEndDate(null);
                                            }}
                                        />
                                    </div>
                                </div>
                                {isLoadingUsers ? <GsSkeletonMainTableCard /> : (
                                    <>
                                        <DataTable value={allUserStats} paginator showGridlines rows={20} removableSort dataKey="userID" filters={filters} filterDisplay="row" globalFilterFields={['fullName', 'email']} emptyMessage="No users found.">
                                            <Column 
                                                field="fullName" 
                                                header="Name" 
                                                filter filterPlaceholder="Search by name" 
                                                style={{ minWidth: '12rem' }} 
                                                body={(rowData) => (
                                                    <span 
                                                        className={classes.tableUser} 
                                                        onClick={() => {handleUserClick(rowData.userID, rowData.fullName)}}>
                                                        {rowData.fullName}
                                                    </span>
                                                )}
                                            />
                                            <Column field="email" header="Email" filter filterPlaceholder="Search by email" style={{ minWidth: '12rem' }} />
                                            <Column field="totalSites" header="Site count" sortable style={{ minWidth: '4rem' }} />
                                            <Column field="created" header="Created" sortable style={{ minWidth: '10rem' }} />
                                            <Column field="lastLoggedIn" header="Last login" sortable style={{ minWidth: '10rem' }} />
                                        </DataTable>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>

                <Outlet />
            </div>
        </>
    )
}

export default GroupSites

export async function loader() {
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const apiData = {
        token,
        client
    }

    return defer({
        groupSites: getGroupSites(apiData, "EyeSpyFX")
    })
}